<template>
  <Pagination
    :current-page="1"
    component-name="EventEntry"
    data-attribute-name="entry"
    :data-list="dataList"
    :entries-per-page="5"
    :key-function="item => item.title + item.dateRange[0]"
  />
</template>

<script>
import Vue from 'vue';
import Pagination from '../shared/Pagination.vue';
import EventEntry from '../shared/EventEntry.vue';
import eventList from '../assets/eventList';

Vue.component('EventEntry', EventEntry);

export default {
  name: 'EventOverview',
  data: () => ({
    dataList: eventList,
  }),
  components: { Pagination },
};
</script>

<style scoped></style>
